import request from '@utils/request'
import configRequest from "@src/config/request";
import { saveCookie } from '@utils/cookie'
import router from "@router/index";

export const state = {
  menuSolution: [],
  menuProduct: [],
  menuBrand: [],
  currentSetting: null,
  lang: ""
};

export const mutations = {
  SET_MENU(state, newValue) {
    state.menuSolution = newValue.solution_category;
    state.menuProduct = newValue.product_parent_category;
    state.menuBrand = newValue.brand;
  },
  SET_CURRENT_SETTING(state, newValue) {
    state.currentSetting = newValue;
  },
  SET_CURRENT_LANG(state, newValue) {
    state.lang = newValue;
  },
};

export const actions = {
  setMenu({ commit }, menu) {
    commit('SET_MENU', menu)
  },

  fetchMenu({ commit }) { // 取得用於網路行為的menu
    return request.post('/menu/search', {
      paginate: 0,
      limit: 0
    })
  },

  recordMenuLog({ commit }, alias) { // 用於更新網路行為的menu log
    return request.get(`/menu/${alias}`)
  },

  contact({ commit }, data) {
    return request.post('/customer/message/send', data)
  },

  fetchStaticItem({ commit }, article) {
    return request.get(`/item/${article}/list`)
      .then((response) => response.items)
  },

  fetchSetting({ commit, state }, lang = undefined) {
    const cached = state.currentSetting;
    const hasCached = !!cached;
    let isLangChange = false
    if(lang === undefined) {
      lang = window.location.pathname.split("/")[1]
      if(lang !== "en") {
        lang = "zh-TW"
      }
    }
    if(lang !== state.lang) {
      commit('SET_CURRENT_LANG', lang);
      isLangChange = true
    }
    return hasCached && !isLangChange
      ? state
      : request.get(
        '/setting/' + lang,
        {
          ...configRequest,
          showMessage: false,
          name: 'fetchSetting'
        }
      )
        .then((response) => {
          commit('SET_CURRENT_SETTING', response.items);

          return response
        })
  },

  subscribe({ commit }, data) {
    return request.post('/newsletter/subscribe', data)
  },

  fetchKeyword({ commit }, data) {
    return request.post('/tag/search', data)
      .then((response) => response.items)
  },

  fetchKeywordClick({ commit }, alias) {
    return request.get(`/tag/${alias}`)
  },

  searchArticle({ commit }, data) {
    return request.post('/site/search', data)
      .then(({ items, pagination }) => {
        return {
          items,
          pagination
        }
      })
  },

  applyRMA({ commit }, data) {
    return request.post('/rma/add', data)
      .then((response) => response.items)
  },

  searchRMA({ commit }, data) {
    return request.post('/rma/search', data)
      .then((response) => response.items)
  },

  searchFile({ commit }, data) {
    return request.post('/file/search', data)
      .then(({ items, pagination }) => {
        return {
          items,
          pagination
        }
      })
  },

  fetchHome({ commit }, data) {
    return request.get(`/homepage`)
      .then((response) => response.items)
  },

  checkVat({ commit }, vat) { // 24968846
    return request.get(`/company/${vat}`, {
      ...configRequest,
      showMessage: false,
      name: 'checkVat',
    })
      .then((res) => {
        saveCookie('companyVat', res.items.mailDomains)
        return res
      })
  },

  fetchFile({ commit }, { url, responseType = 'blob' } = {}) {
    return request.post(url, {}, { responseType })
      .then((response) => response)
  },
};